import React from 'react';
import { motion } from 'framer-motion';
interface CTAButtonProps {
  text?: string;
  onClick?: () => void;
  className?: string;
}
export function CTAButton({
  text = '¡SÍ, QUIERO RECUPERAR MI CLARIDAD MENTAL AHORA!',
  onClick,
  className = ''
}: CTAButtonProps) {
  return <motion.button whileHover={{
    scale: 1.02
  }} whileTap={{
    scale: 0.98
  }} onClick={onClick} className={`w-full bg-forest hover:bg-forest-dark text-white font-bold py-4 px-6 rounded-xl shadow-lg transition-colors duration-300 text-lg md:text-xl leading-tight ${className}`} data-id="element-193">
      {text}
    </motion.button>;
}